<template>
  <div class="mt-8">
    <px-view-module-header module-name="Empresa" :breadcrumbs="breadcrumbs"/>
    <v-card class="rounded-card card-shadow mt-8">
      <v-card-text class="text--primary">
        <px-view-header-title title="Minha conta"/>
        <div class="ml-4 mt-3">
          <h3 class="mb-3">{{ user.nome }}</h3>
          <p>
            <v-icon>mdi-domain</v-icon>
            {{ user.cpf | cpf }}
          </p>
          <div>
            <v-icon>mdi-email</v-icon>
            {{ user.email }}
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('user', ['user', 'loading']),
  },
  data() {
    return {
      breadcrumbs: [
        { text: 'Minha conta' },
      ],
    };
  },
};
</script>
